import { useState } from "react";
import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  kind: "movie" | "novel";
  id: string;
}

export default function FavoriteButton({ kind, id }: FavoriteButtonProps) {
  const { isFavorite, toggle } = useFavorites(kind);
  const active = isFavorite(id);
  const [toast, setToast] = useState<string | null>(null);

  const handleClick = () => {
    toggle(id);
    setToast(active ? "已取消收藏" : "已加入收藏");
    window.setTimeout(() => setToast(null), 1800);
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={handleClick}
        className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
          active
            ? "bg-accent-500 text-foreground-950 hover:bg-accent-600"
            : "bg-background-100 text-foreground-800 border border-background-300 hover:border-accent-400 hover:text-accent-700"
        }`}
      >
        <i className={active ? "ri-heart-fill" : "ri-heart-line"}></i>
        {active ? "已收藏" : "收藏"}
      </button>
      {toast && (
        <span className="absolute left-1/2 -translate-x-1/2 -top-10 px-3 py-1.5 rounded-md bg-foreground-950 text-background-50 text-xs whitespace-nowrap animate-fade-in">
          {toast}
        </span>
      )}
    </div>
  );
}